import groq from "groq";

export const filters = Object.freeze({
  isDraft: groq`_id in path('drafts.**')`,
  isNotDraft: groq`!(_id in path('drafts.**'))`,
  siteRef: groq`(site._ref == $siteId || !defined(site))`,
});
